let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hV2d")).then(() => parcelRequire('226GG'));